_ = require('lodash')
moment = require('moment')

ClubService = ($http, $q, $location) ->
  getClub: (clubId) ->
    delay = $q.defer()
    $http.get("/api/clubs/#{clubId}.json").then (resp) ->
      delay.resolve resp.data
    delay.promise

  getCourses: (clubId) ->
    $http.get("/api/clubs/#{clubId}/courses.json")

  getYardage: (courseId) ->
    delay = $q.defer()
    $http.get("/api/courses/#{courseId}/yardage.json").then (resp) ->
      delay.resolve resp.data
    delay.promise
  getAnalysis: (courseId) ->
    delay = $q.defer()
    $http.get("/api/courses/#{courseId}/analysis.json").then(
      (resp) -> delay.resolve resp.data,
      -> delay.reject()
    )
    delay.promise

  getRecommendPlans: (rakuten_id) ->
    delay = $q.defer()
    playDate = moment().add(14, 'days').format "YYYY-MM-DD"
    $http.jsonp('https://app.rakuten.co.jp/services/api/Gora/GoraPlanSearch/20170623', params:
      format: 'json'
      applicationId: '1083670463465254180'
      golfCourseId: rakuten_id
      playDate: playDate
    ).then (resp) ->
      delay.resolve resp.data
    delay.promise

  getRecentUsers: (clubId, params) ->
    $http.get("/api/clubs/#{clubId}/users/played.json", params: params)

  getRankingUsers: (clubId, params = {}) ->
    $http.get("/api/clubs/#{clubId}/ranking_users.json", params: params)

ClubService.$inject = [
  '$http'
  '$q'
  '$location'
]

module.exports = ClubService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-service.coffee